"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.decorator = void 0;
Object.defineProperty(exports, "getBlockAlignment", {
  enumerable: true,
  get: function () {
    return _getBlockAlignment.default;
  }
});
exports.toolbarEditorProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _draftJs = require("draft-js");
var _ColorControls = _interopRequireWildcard(require("./ColorControls"));
var _FontControls = _interopRequireWildcard(require("./FontControls"));
var _HistoryControls = _interopRequireDefault(require("./HistoryControls"));
var _LinkControls = _interopRequireWildcard(require("./LinkControls"));
var _AlignmentControls = _interopRequireDefault(require("./AlignmentControls"));
var _MediaControls = _interopRequireWildcard(require("./MediaControls"));
var _getBlockAlignment = _interopRequireDefault(require("./AlignmentControls/getBlockAlignment"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
if (require('exenv').canUseDOM) require('./styles.scss');
class Toolbar extends _react.Component {
  toggleInlineStyle(style) {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    setEditorState(_draftJs.RichUtils.toggleInlineStyle(editorState, style));
    this.props.focusEditor();
  }
  toggleBlockType(blockType) {
    const _this$props2 = this.props,
      editorState = _this$props2.editorState,
      setEditorState = _this$props2.setEditorState;
    setEditorState(_draftJs.RichUtils.toggleBlockType(editorState, blockType));
    this.props.focusEditor();
  }
  hasInlineStyle(inlineStyle) {
    const editorState = this.props.editorState;
    const hasStyle = editorState.getCurrentInlineStyle().filter(style => style === inlineStyle);
    return hasStyle.size > 0 ? 'active' : null;
  }
  hasBlockType(blockType) {
    const editorState = this.props.editorState;
    const selectionState = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selectionState.getStartKey());
    return block.getType() === blockType ? 'active' : null;
  }
  render() {
    const _this$props3 = this.props,
      editorState = _this$props3.editorState,
      setEditorState = _this$props3.setEditorState,
      focusEditor = _this$props3.focusEditor,
      buttonClassName = _this$props3.buttonClassName,
      popoverClassName = _this$props3.popoverClassName,
      theme = _this$props3.theme,
      style = _this$props3.style;
    const controlsProps = {
      editorState,
      setEditorState,
      focusEditor
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "toolbar absolute full-width top-0 left-0 bg-darken-4 flex flex-wrap",
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, this.hasInlineStyle('BOLD')),
      onClick: () => this.toggleInlineStyle('BOLD')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-bold"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, this.hasInlineStyle('ITALIC')),
      onClick: () => this.toggleInlineStyle('ITALIC')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-italic"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, this.hasInlineStyle('UNDERLINE')),
      onClick: () => this.toggleInlineStyle('UNDERLINE')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-underline"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, this.hasBlockType('ordered-list-item')),
      onClick: () => this.toggleBlockType('ordered-list-item')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-list-ol"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, this.hasBlockType('unordered-list-item')),
      onClick: () => this.toggleBlockType('unordered-list-item')
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-list-ul"
    }))), /*#__PURE__*/_react.default.createElement(_LinkControls.default, (0, _extends2.default)({
      buttonClassName: buttonClassName,
      popoverClassName: popoverClassName
    }, controlsProps)), /*#__PURE__*/_react.default.createElement(_ColorControls.default, (0, _extends2.default)({
      theme: theme,
      buttonClassName: buttonClassName
    }, controlsProps)), /*#__PURE__*/_react.default.createElement(_FontControls.default, (0, _extends2.default)({
      initialValue: {
        fontSize: 15,
        fontFamily: ''
      }
    }, controlsProps)), /*#__PURE__*/_react.default.createElement(_HistoryControls.default, (0, _extends2.default)({
      buttonClassName: buttonClassName
    }, controlsProps)), /*#__PURE__*/_react.default.createElement(_AlignmentControls.default, (0, _extends2.default)({
      buttonClassName: buttonClassName
    }, controlsProps)), /*#__PURE__*/_react.default.createElement(_MediaControls.default, (0, _extends2.default)({
      buttonClassName: buttonClassName,
      popoverClassName: popoverClassName
    }, controlsProps)));
  }
}
const toolbarEditorProps = exports.toolbarEditorProps = {
  blockRendererFn: _MediaControls.blockRendererFn,
  customStyleFn: style => {
    return _objectSpread(_objectSpread({}, (0, _FontControls.customStyleFn)(style)), (0, _ColorControls.customStyleFn)(style));
  }
};
const decorator = exports.decorator = new _draftJs.CompositeDecorator([_LinkControls.decorator]);
var _default = exports.default = Toolbar;